/**
 * Shared form-validator regex patterns.
 *
 * Strings (not RegExp instances) because Angular's `Validators.pattern` accepts
 * both, and strings keep the source compatible with templates that interpolate.
 *
 * Add new entries here rather than inlining patterns in field configs —
 * inline patterns drift, and a typo in one of N copies is hard to notice.
 */
export const VALIDATION_PATTERN = {
  /** One or more digits. Useful for phone numbers, account numbers,
   *  till/paybill numbers — anything that should be numeric-only. */
  NUMERIC: '[0-9]+',

  /** Alphanumeric with spaces. Used for human-entered free text where
   *  punctuation is not allowed (org names, beneficiary names). */
  ALPHANUMERIC_SPACE: '[a-zA-Z0-9 ]+',

  /** Alphanumeric only (no spaces). For codes/identifiers. */
  ALPHANUMERIC: '[a-zA-Z0-9]+',

  /** SWIFT/BIC: 8 or 11 uppercase letters and digits. */
  SWIFT: '^[A-Z0-9]{8}([A-Z0-9]{3})?$',

  /** IBAN: 2-letter country, 2-digit checksum, up to 30 alphanumeric. */
  IBAN: '^[A-Z]{2}\\d{2}[A-Z0-9]{1,30}$',

  BENEFICIARY_ADDRESS_PATTERN: /^[a-zA-Z0-9 .,()/<>='+:?!"%%*;&{#_-]*$/
} as const;

export type ValidationPatternKey = keyof typeof VALIDATION_PATTERN;
